export const adminsConstants = {
  SET_ADMINS_LOADING: 'admins/SET_ADMINS_LOADING',
  SET_ASSIGNABLE_LOCATIONS_LOADING: 'admins/SET_ASSIGNABLE_LOCATIONS_LOADING',
  SET_ACTIVITY_RECORDS_LOADING: 'admins/SET_ACTIVITY_RECORDS_LOADING',
  GET_ADMINS: 'admins/GET_ADMINS',
  CLEAR_ADMINS: 'admins/CLEAR_ADMINS',
  GET_ADMIN: 'admins/GET_ADMIN',
  GET_ASSIGNABLE_LOCATIONS: 'admins/GET_ASSIGNABLE_LOCATIONS',
  GET_ACTIVITY_RECORDS: 'admins/GET_ACTIVITY_RECORDS',
  SET_ADMIN: 'admins/SET_ADMIN',
  SET_ADMINS: 'admins/SET_ADMINS',
  SET_ASSIGNABLE_LOCATIONS: 'admins/SET_ASSIGNABLE_LOCATIONS',
  SET_ACTIVITY_RECORDS: 'admins/SET_ACTIVITY_RECORDS',
  ADD_ADMIN: 'admins/ADD_ADMIN',
  EDIT_ADMIN: 'admins/EDIT_ADMIN',
  DEACTIVATE_ADMIN: 'admins/DEACTIVATE_ADMIN',
};
